export enum AppSection {
  Registration,
  Identification,
  Verification,
}
